module.exports = __webpack_public_path__ + "img/caprock_logo1.c7c15709.svg";